import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { microfrontendConfig } from '@/infrastructure/config/microfrontend.config';

import Microcertificate from '../screens/microcertificate/microcertificate';

export const Router = () => {
  const basename = microfrontendConfig.getBasename();

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route>
          <Route path="/:microcertHash" element={<Microcertificate />} />
          <Route path="*" element={<Microcertificate />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
